import { Outlet } from "react-router-dom";
import { OnboardingToolbar } from "@/features/onboarding/components/onboarding-toolbar";
import { MomentBeacon } from "@/features/moments/moment-beacon";

export function OnboardingLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background notranslate" translate="no" lang="en">
      <MomentBeacon />
      <OnboardingToolbar />
      <div className="flex flex-1 justify-center">
        <div className="w-full max-w-3xl p-6 pt-16 sm:p-8 sm:pt-24">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
